(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/themes/sport-cricket/assets/javascripts/init-box.js') >= 0) return;  svs.modules.push('/components/themes/sport-cricket/assets/javascripts/init-box.js'); "use strict";

(function (svs) {
  svs = svs || {};
  svs.themes = svs.themes || {};
  svs.themes.sport_cricket = svs.themes.sport_cricket || {};

  svs.themes.sport_cricket.initStatusStart = function (data) {
    if (svs.themes.sport_cricket.isLive(data.status.id)) {
      if (data.status.id > 104 && data.status.id < 109) {
        return "<div class=\"brick match-status brick-active f-condensed align-center\">INN ".concat(Math.ceil((data.status.id - 104) / 2), "</div>");
      } else if (_.contains([19, 110, 111], data.status.id)) {
        return '<div class="brick match-status brick-active f-condensed align-center">ÖT</div>';
      } else if (_.contains([14, 16, 17, 109, 122, 123], data.status.id)) {
        return '<div class="brick match-status brick-active f-condensed align-center">PAUS</div>';
      } else if (data.status.id === 113) {
        return '<div class="brick match-status brick-active f-condensed align-center">UPPH</div>';
      }

      return '';
    } else if (svs.themes.sport_cricket.isEnded(data.status.id)) {
      if (data.status.id === 26) {
        return '<div class="brick match-status brick-border brick-inactive f-condensed align-center">AVBR</div>';
      } else if (data.status.id === 28) {
        return '<div class="brick match-status brick-border brick-inactive f-condensed align-center">UPPH</div>';
      }

      return '<div class="brick match-status brick-border brick-inactive f-condensed align-center">FT</div>';
    } else if (data.startTime) {
      return "<div class=\"brick match-status brick-border f-condensed align-center\">".concat(svs.themes.formatTime(data.startTime), "</div>");
    }

    return '';
  };


  svs.themes.sport_cricket.hasMatchMinutes = function () {
    return false;
  };
})(svs);
 })(window);